import { Box, Group } from '@mantine/core'
import { Outlet } from 'react-router'
import { createTestIdScope } from '@m3-tech/boss-utils'
import { SIDEBAR_STICKY_OFFSETS, SidebarNav } from '@m3-tech/boss-ui'
import { TEST_ID_BASE, TestIdPage, TestIdSection } from '@/constants/testIds'
import { useSettingsNavItems } from '@/constants/settingsNavItems'

export function SettingsLayout() {
    const tid = createTestIdScope(`${TEST_ID_BASE}-${TestIdPage.SETTINGS}`)
    const items = useSettingsNavItems()

    return (
        <Group wrap="nowrap" align="flex-start" gap="md" style={SIDEBAR_STICKY_OFFSETS}>
            <SidebarNav items={items} testId={tid(TestIdSection.SIDEBAR)} />
            <Box flex={1} pb="xl" px="lg" miw={0} data-testid={tid(TestIdSection.CONTENT)}>
                <Outlet />
            </Box>
        </Group>
    )
}
